import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { NotificationHeaderWrapper } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenu';
import {
    NotificationListContainer,
    NotificationsMenuBetsItemContainer,
} from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenuLists/NotificationsMenuLists.style';
import { useCommon } from 'src/AppState/Common';
import { NotificationsCentreState } from 'src/components/NotificationsCentre/NotificationsCentreState';
import { NotificationsMenuChatItem } from './NotificationsChatItem';
import { action, makeAutoObservable, observable } from 'mobx';
import { NotificationItemContainer } from 'src/components/Header/LHSMenu/NotificationsMenu/NotificationsMenu.style';
import { ChatBubbleIcon } from '@radix-ui/react-icons';

class NotificationsChatListState {
    @observable public isOpen: boolean = true;

    public constructor() {
        makeAutoObservable(this);
    }

    @action public toggleOpen = (): void => {
        this.isOpen = !this.isOpen;
    };
}

export const NotificationsMenuChat = observer('NotificationsMenuChat', (): JSX.Element | null => {
    const common = useCommon();
    const stateCenter = NotificationsCentreState.get(common);
    const [state] = React.useState(() => new NotificationsChatListState());

    const notifications = stateCenter.chatNotifications;

    const pendingChatItems: Array<JSX.Element> = [];
    const ongoingChatItems: Array<JSX.Element> = [];

    notifications.forEach((notification) => {
        const status = notification.status;
        const item = <NotificationsMenuChatItem chatItem={notification} />;

        if (status === 'pending') {
            pendingChatItems.push(
                <NotificationsMenuBetsItemContainer
                    key={notification.id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationsMenuBetsItemContainer>
            );
        } else {
            ongoingChatItems.push(
                <NotificationsMenuBetsItemContainer
                    key={notification.id}
                    data-test='notifications-list-item'
                >
                    {item}
                </NotificationsMenuBetsItemContainer>
            );
        }
    });

    return (
        <NotificationItemContainer>
            <NotificationHeaderWrapper
                name='Chat'
                icon={<ChatBubbleIcon />}
                onClick={state.toggleOpen}
                isOpen={state.isOpen}
            />

            <NotificationListContainer isOpen={state.isOpen}>
                {pendingChatItems}
                {ongoingChatItems}
            </NotificationListContainer>
        </NotificationItemContainer>
    );
});
